
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const HistoryDismiss20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M10 4a6 6 0 0 1 5.95 5.2c.36.1.7.23 1.04.4A7 7 0 0 0 5 5.1V3.5a.5.5 0 0 0-1 0v3c0 .28.22.5.5.5h3a.5.5 0 0 0 0-1H5.53c1.1-1.23 2.7-2 4.47-2Zm.26 7c.31-.38.67-.72 1.08-1H10V6.5a.5.5 0 0 0-1 0v4c0 .28.22.5.5.5h.76Zm-.67 5.99c-.16-.33-.3-.68-.4-1.04a6 6 0 0 1-5.17-6.41.5.5 0 1 0-1-.08A7 7 0 0 0 9.59 17ZM19 14.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm-2.65-1.15a.5.5 0 0 0-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 0 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 0 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 0 0 .7-.7l-1.14-1.15 1.14-1.15Z"
            fill="currentColor"
        />
    </svg>
}